module.exports = __webpack_public_path__ + "static/media/logo-external.b362008a.png";